import { strCode } from "../consts";
import { t } from "../services";

const getFilteredOptions = (filteredOptions, searchText) => {
  const trimmedSearchText = searchText.trim();
  return filteredOptions.some((x) => x.value === searchText) || trimmedSearchText.length === 0
    ? filteredOptions
    : [
        ...filteredOptions,
        {
          id: trimmedSearchText,
          value: `${trimmedSearchText} (${t(strCode.NEW_GROUP)})`
        }
      ];
};

const groupUtils = {
  getFilteredOptions
};

export default groupUtils;
